export default __webpack_public_path__ + "static/CategoriesBg-4945bb9acdb921c1f1da86cce342db72.svg";